"use client";

import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createTextNode, $insertNodes } from "lexical";
import MobileWrapperDialog from "../mobile-wrapper-dialog/MobileWrapperDialog";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import { useEmoji } from "@/contexts/EmojiContext";
interface CreateDropEmojiPickerProps {
  top?: string | undefined;
}
const CreateDropEmojiPicker: FC<CreateDropEmojiPickerProps> = t0 => {
  const $ = _c(36);
  const {
    top: t1
  } = t0;
  const top = t1 === undefined ? "tw-top-2" : t1;
  const isMobile = useIsMobileScreen();
  const {
    emojiMap,
    categories,
    categoryIcons
  } = useEmoji();
  const [editor] = useLexicalComposerContext();
  const [showPicker, setShowPicker] = useState(false);
  const buttonRef = useRef(null);
  const pickerRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      top: 0,
      left: 0
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [pickerPosition, setPickerPosition] = useState(t2);
  let t3;
  if ($[1] !== editor) {
    t3 = emoji => {
      let emojiText = emoji.native;
      if (!emojiText && emoji.id) {
        emojiText = `:${emoji.id}:`;
      }
      if (emojiText) {
        editor.update(() => {
          const emojiNode = $createTextNode(emojiText);
          $insertNodes([emojiNode]);
        });
        requestAnimationFrame(() => {
          editor.focus();
          editor.update(_temp);
        });
      }
      setShowPicker(false);
    };
    $[1] = editor;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const addEmoji = t3;
  let t4;
  let t5;
  if ($[3] !== showPicker) {
    t4 = () => {
      if (showPicker && buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        setPickerPosition({
          top: rect.top + window.scrollY - 420,
          left: rect.left + window.scrollX - 250
        });
      }
    };
    t5 = [showPicker];
    $[3] = showPicker;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[6] !== showPicker) {
    t6 = () => {
      const handleClickOutside = event => {
        if (pickerRef.current && !pickerRef.current.contains(event.target as Node) && buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
          setShowPicker(false);
        }
      };
      if (showPicker) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }
      return () => document.removeEventListener("mousedown", handleClickOutside);
    };
    t7 = [showPicker];
    $[6] = showPicker;
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  useEffect(t6, t7);
  const t8 = `tw-absolute tw-right-2 ${top} tw-flex tw-justify-center tw-items-start`;
  let t9;
  if ($[9] !== showPicker) {
    t9 = () => setShowPicker(!showPicker);
    $[9] = showPicker;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <svg className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-transition tw-ease-out tw-duration-300" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><g transform="scale(0.024)"><path d="M958 104h-62V43q0-17-12-29T855 2h-87q-17 0-29 12t-12 29v61h-62q-17 0-29 12t-12 29v4q-81-34-169-34-116 0-217 59-97 57-154 154-58 100-58 216.5T84 761q57 98 154 155 101 58 217.5 58T672 916q97-57 154-155 59-100 59-216 0-88-34-168h4q17 0 29-12t12-29v-62h62q17 0 29-12t12-29v-88q0-17-12-29t-29-12zM644 348q29 0 49.5 20.5t20.5 49-20.5 49T644 487t-49.5-20.5-20.5-49 20.5-49T644 348zm-377 0q29 0 49.5 20.5t20.5 49-20.5 49T267 487t-49.5-20.5-20.5-49 20.5-49T267 348zm473 255q-10 70-50.5 126.5t-102 88.5-132 32-132-32-102-88.5T171 603q-2-16 8.5-27.5T206 564h499q16 0 26.5 11.5T740 603zm218-370H855v103h-87V233H665v-88h103V43h87v102h103v88z" /></g></svg>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t9) {
    t11 = <button ref={buttonRef} className="tw-p-[0.35rem] tw-border-none tw-rounded tw-bg-transparent hover:tw-bg-[rgb(40,40,40)] tw-opacity-50 hover:tw-opacity-100 tw-transition tw-duration-150 tw-flex tw-items-center tw-justify-center hover:tw-text-[#FFCC22]" onClick={t9}>{t10}</button>;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== addEmoji || $[15] !== categories || $[16] !== categoryIcons || $[17] !== emojiMap || $[18] !== isMobile || $[19] !== pickerPosition || $[20] !== showPicker) {
    t12 = !isMobile && showPicker && createPortal(<div ref={pickerRef} style={{
      position: "absolute",
      top: pickerPosition.top,
      left: pickerPosition.left,
      zIndex: 1000
    }} className="tw-shadow-lg tw-rounded-lg tw-border tw-bg-iron-800 tw-p-[1px]"><Picker theme="dark" data={data} onEmojiSelect={addEmoji} custom={emojiMap} categories={categories} categoryIcons={categoryIcons} /></div>, document.body);
    $[14] = addEmoji;
    $[15] = categories;
    $[16] = categoryIcons;
    $[17] = emojiMap;
    $[18] = isMobile;
    $[19] = pickerPosition;
    $[20] = showPicker;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12 || $[24] !== t8) {
    t13 = <div className={t8}>{t11}{t12}</div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t8;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== addEmoji || $[27] !== categories || $[28] !== categoryIcons || $[29] !== emojiMap || $[30] !== isMobile || $[31] !== showPicker) {
    t14 = isMobile && <MobileWrapperDialog isOpen={showPicker} onClose={() => setShowPicker(false)}><div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center" onTouchMove={_temp2}><Picker theme="dark" data={data} onEmojiSelect={addEmoji} custom={emojiMap} categories={categories} categoryIcons={categoryIcons} /></div></MobileWrapperDialog>;
    $[26] = addEmoji;
    $[27] = categories;
    $[28] = categoryIcons;
    $[29] = emojiMap;
    $[30] = isMobile;
    $[31] = showPicker;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = <>{t13}{t14}</>;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};
export default CreateDropEmojiPicker;
function _temp() {}
function _temp2(e) {
  return e.stopPropagation();
}